import { Direction } from '~shared/utils/sort';
import { sortItemsByProperty } from '~shared/utils/sort/sortItemsByProperty';
import { sortItemsByManyProperties } from '~shared/utils/sort/sortItemsByManyProperties';
import { sortNaturalString } from '~shared/utils/sort/sortNaturalString';
import { QuizListColumn } from '~teacher/components/quizzes/QuizList/useColumnSortReducer';

import { QuizOrFolder } from '../../api/quiz/getQuizzes/types';

interface SortQuizListItemsParams {
  items: QuizOrFolder[];
  sortProperty: QuizListColumn;
  sortDirection: Direction;
}

const sortPropToItemProp = {
  [QuizListColumn.Title]: 'name',
  [QuizListColumn.Modified]: 'date',
  // [QuizListColumn.Owner]: 'owner',
};

/**
 * This is used to sort the table on a given property
 *
 * Note, that we always sort on type so that quizzes and folders are grouped together
 *
 * @param items - The items to sort
 * @param sortProperty - Which property should be sorted on?
 * @param sortDirection - The direction to sort.
 */
export function sortQuizListItems({
  items,
  sortProperty,
  sortDirection,
}: SortQuizListItemsParams) {
  if (sortProperty === QuizListColumn.Title) {
    const nameSortedItems = [...items].sort((a, b) =>
      sortNaturalString({
        a: a.name,
        b: b.name,
        sortDirection,
      })
    );

    return sortItemsByProperty({
      items: nameSortedItems,
      property: 'type',
      sortDirection: Direction.Ascending,
    });
  }

  const itemProperty = sortPropToItemProp[sortProperty];

  return sortItemsByManyProperties({
    items: items,
    itemSorts: [
      { property: itemProperty, sortDirection: sortDirection },
      { property: 'type', sortDirection: Direction.Ascending },
    ],
  });
}
